import type { TransactionRow } from '../../../Containers/Customer/CustomerTransactions.types';

export interface InvoiceRowActionsVisibility {
  sendCopyDisabled: boolean;
  showDelete: boolean;
  showRegisterRepayment: boolean;
  showCredit: boolean;
}

export const getInvoiceRowActions = (
  row: TransactionRow,
  isInvoiceAdmin: boolean
): InvoiceRowActionsVisibility => {
  const isSentInvoice = row.hasPdf || (row.type === 'vossOnlySent' && Boolean(row.invoiceNumber));
  return {
    sendCopyDisabled: !row.hasPdf,
    showDelete: isInvoiceAdmin && row.isUninvoiced,
    showRegisterRepayment: isInvoiceAdmin && row.hasPdf,
    showCredit: isInvoiceAdmin && isSentInvoice && row.amount > 0,
  };
};
